export default {
    namespaced: true,
    state: {
        data: {}
    },
    mutations: {
        data(state, {key, options}) {
            state.data[key] = options
        }
    },
    actions: {
        async get({state, dispatch, commit}, {tableName, fieldName, optionsArray}) {
            const key = `${tableName}:${fieldName}`
            
            if (state.data[key]) return state.data[key]
            
            let options
            if (tableName === 'pages' && fieldName === 'class') {
                options = await dispatch('pages/classNames', {}, {root: true})
            } else {
                options = optionsArray ? optionsArray.map(o => o.value) : []
                
                let values = (await dispatch('request/get', {
                    url: 'api/component/' + tableName + '/' + fieldName,
                    params: {
                        groupBy: fieldName, sort: fieldName
                        // Not all components have an archive option. To reinstate this it will need to check
                        // the component's settings.
                        //isArchived: 0
                    }
                }, {root: true})).data.values.filter(Boolean)
                
                options.push(...values)
            }
            
            optionsArray = [...new Set(options)] // Remove duplicates
                .map(value => ({value, text: value}))
                .sort((a, b) => (a.text > b.text) ? 1 : -1)
            
            commit('data', {key, options: optionsArray})
            
            return optionsArray
        },
        clearData({state}, {tableName}) {
            Object.keys(state.data)
                .filter(key => key.startsWith(`${tableName}:`))
                .forEach(key => delete state.data[key])
        }
    }
}